import GridComponent from './GridComponent';

export default GridComponent;
